if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  window.debounce = debounce
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}
  var event = new CustomEvent(eventName, data ? { detail: data } : null)
  document.dispatchEvent(event)
}

;(function () {
  window.theme = window.theme || {}
  var theme = window.theme

  theme.network = theme.network || {}
  theme.network._handling429 = theme.network._handling429 || false
  theme.network._parse429Message = function (text) {
    var fallback = 'System detected unusual traffic, please refresh for verification.'

    if (!text) return fallback

    try {
      var tMatch = text.match(/var\s+t\s*=\s*(\{[\s\S]*?\});/)
      if (tMatch && tMatch[1]) {
        var t = JSON.parse(tMatch[1])
        var locale = window.Shopify && window.Shopify.locale || 'en'
        var translations = t[locale] || t['en']
        if (translations && translations['content-title']) {
          return translations['content-title']
        }
      }

      var h1Match = text.match(/<h1[^>]*>(.*?)<\/h1>/i)
      var titleMatch = text.match(/<title[^>]*>(.*?)<\/title>/i)
      if (h1Match && h1Match[1]) return h1Match[1].trim()
      if (titleMatch && titleMatch[1]) return titleMatch[1].trim()
    } catch (e) {}

    return fallback
  }
  theme.network.handle429 = function (options) {
    if (theme.network._handling429) return
    theme.network._handling429 = true

    var retryAfter = options && options.retryAfter
    var message
    if (retryAfter) {
      message = 'Too many requests. Please try again later.'
    } else {
      message = theme.network._parse429Message(options && options.text)
    }

    try {
      alert(message)
    } catch (e) {}

    if (!retryAfter) {
      try {
        window.location.reload()
      } catch (e) {}
    }
  }

  ;(function () {
    if (!window.fetch) return
    if (window.fetch.__elegoo429Wrapped) return

    var originalFetch = window.fetch
    var wrappedFetch = function () {
      const args = arguments
      return originalFetch.apply(this, args).then(function (response) {
        try {
          // only current host and cart api
          if (!/\/cart/.test(args[0])) return response
        } catch(err) { console.log(err) }
        if (!response || response.status !== 429) return response

        var retryAfter = null
        try {
          retryAfter =
            response.headers && response.headers.get ? response.headers.get('Retry-After') : null
        } catch (e) {}

        try {
          var cloned = response.clone()
          return cloned
            .text()
            .then(function (text) {
              theme.network.handle429({ text: text, retryAfter: retryAfter })
              return response
            })
            .catch(function () {
              theme.network.handle429({ retryAfter: retryAfter })
              return response
            })
        } catch (e) {
          theme.network.handle429({ retryAfter: retryAfter })
          return response
        }
      })
    }

    wrappedFetch.__elegoo429Wrapped = true
    wrappedFetch.__elegoo429Original = originalFetch
    window.fetch = wrappedFetch
  })()

  if (!theme.network._ajax429Bound) {
    theme.network._ajax429Bound = true
    
    // Intercept XMLHttpRequest for 429 handling without jQuery dependency
    var originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function() {
      var self = this;
      self.addEventListener('readystatechange', function() {
        if (self.readyState === 4 && self.status === 429) {
          var retryAfter = null;
          try {
            retryAfter = self.getResponseHeader ? self.getResponseHeader('Retry-After') : null;
          } catch (e) {}
          theme.network.handle429({
            text: self.responseText,
            retryAfter: retryAfter
          });
        }
      });
      return originalSend.apply(this, arguments);
    };
  }
})()

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super()
      this.input = this.querySelector('.qty')
      this.step = this.input.getAttribute('step')
      this.changeEvent = new Event('change', {
        bubbles: true,
      })
      // Create buttons
      this.subtract = this.querySelector('.minus')
      this.add = this.querySelector('.plus')
      // Add functionality to buttons
      this.addEventListener('click', (evt) => {
        if (evt.currentTarget.contains(evt.target.closest('.minus'))) {
          this.change_quantity(-1 * this.step)
        }
        if (evt.currentTarget.contains(evt.target.closest('.plus'))) {
          this.change_quantity(1 * this.step)
        }
      })
      this.input.addEventListener('change', () => {
        this.validateQtyRules()
        dispatchCustomEvent('quantity:change', {
          value: parseInt(this.input.value, 10) || 0,
          input: this.input,
        })
      })

      this.validateQtyRules()
    }
    connectedCallback() {
      this.classList.add('buttons_added')
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value)

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1

      // Check for min & max
      if (this.input.getAttribute('min') > quantity + change) {
        return
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < quantity + change) {
          return
        }
      }

      // Change quantity
      quantity += change

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1)

      // Output number
      this.input.value = quantity

      this.input.dispatchEvent(this.changeEvent)
      dispatchCustomEvent('quantity:change', {
        value: quantity,
        input: this.input,
      })

      this.validateQtyRules()
    }
    validateQtyRules() {
      const value = parseInt(this.input.value)
      if (this.input.min) {
        const min = parseInt(this.input.min)
        this.subtract.classList.toggle('disabled', value <= min)
      }
      if (this.input.max) {
        const max = parseInt(this.input.max)
        this.add.classList.toggle('disabled', value >= max)
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput)
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {
  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu')
    this.arrow = self
    self.addEventListener('click', e => this.toggle_submenu(e))
  }

  toggle_submenu(e) {
    e.preventDefault()
    let submenu = this.submenu

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active')
    } else {
      submenu.classList.remove('active')
      this.arrow.blur()
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow')
arrows.forEach(arrow => {
  new ArrowSubMenu(arrow)
})

const getProductSwatchesData = (() => {
  const promise = new Promise((resolve) => {
    const swatchesScript = document.querySelector('script#product-card-swatches-raw-data');
    if (!swatchesScript) {
      resolve({});
      return;
    }
    const swatchesData = {};
    try {
      const json = JSON.parse(swatchesScript.textContent);
      const keys = json.keys.split(',');
      const values = json.values.split(',');
      for (let i = 0; i < keys.length; i++) {
        swatchesData[keys[i]] = values[i] || '';
      }
    } catch (err) {
      console.error(err);
    }
    // Always resolve (with an empty map on parse failure) so callers never hang.
    resolve(swatchesData);
  });
  return () => promise;
})()

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super()
      this.swatches = this.querySelector('.product-card-swatches')
      this.allSwatches = Array.from(this.querySelectorAll('.product-card-swatches'));
      this.image = this.querySelector('.product-featured-image-link .product-primary-image')
      this.additional_images = this.querySelectorAll('.product-secondary-image')
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li')
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple')
      this.loadingClass = this.dataset.loadingClass || 'loading'
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image)
      }
      if (this.additional_images.length) {
        this.enableAdditionalImages()
      }
      if (this.quick_add) {
        this.enableQuickAdd()
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length
      let images = this.additional_images
      let nav = this.additional_images_nav
      let image_container = this.querySelector('.product-featured-image')
      if (!image_container) return
      const mousemove = function (e) {
        let l = e.offsetX
        let w = this.getBoundingClientRect().width
        let prc = l / w
        let sel = Math.floor(prc * image_length)
        let selimg = images[sel]
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover')
            if (nav.length) {
              nav[index].classList.remove('active')
            }
          }
        })
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover')
            if (nav.length) {
              nav[sel].classList.add('active')
            }
          }
        }
      }
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover')
          if (nav.length) {
            nav[index].classList.remove('active')
          }
        })
      }
      image_container.addEventListener('touchstart', mousemove, {
        passive: true,
      })
      image_container.addEventListener('touchmove', mousemove, {
        passive: true,
      })
      image_container.addEventListener('touchend', mouseleave, {
        passive: true,
      })
      image_container.addEventListener('mouseenter', mousemove, {
        passive: true,
      })
      image_container.addEventListener('mousemove', mousemove, {
        passive: true,
      })
      image_container.addEventListener('mouseleave', mouseleave, {
        passive: true,
      })
    }
    enableSwatches(swatches, image) {
      // let swatch_list = swatches.querySelectorAll('.product-card-swatch');
      let org_srcset = image ? image.dataset.srcset : '';
      // let active = swatches.querySelector('.product-card-swatch.active')

      const allSwatches = this.allSwatches || [];
      allSwatches.forEach(swatches => {
        const swatch_list = swatches.querySelectorAll('.product-card-swatch');
        swatches.addEventListener('mouseover', e => {
          const swatch = e.target?.closest('.product-card-swatch');
          if (!swatch) return
          ;[].forEach.call(swatch_list, function (el) {
            el.classList.remove('active')
          })
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset)
            } else if (org_srcset) {
              image.setAttribute('srcset', org_srcset)
            }
          }

          swatch.classList.add('active')
        })

        swatches.addEventListener('click', function (evt) {
          const swatch = evt.target?.closest('.product-card-swatch')
          const href = swatch?.dataset.href
          if (href) {
            evt.preventDefault()
            window.location.href = href
          }
        })

        getProductSwatchesData()
          .then(data => {
            let latest = Date.now()
            let cur = 0
            const batch = 25
            function step() {
              const now = Date.now()
              if (cur >= swatch_list.length) return
              if (now - 50 > latest) {
                latest = now
                setTimeout(step)
              } else {
                for (let i = 0; i < batch; i++) {
                  const swatch = swatch_list[cur++]
                  if (swatch) {
                    // Swatches resolved via SKU pattern or swatch metaobject in
                    // snippets/product-card-swatch.liquid must not be overridden
                    // by the settings color mapping.
                    if (swatch.dataset.colorResolved === 'true') continue
                    const optionValue = data[swatch.dataset.optionColor]
                    if (optionValue) {
                      if (optionValue?.indexOf('.') > -1) {
                        swatch.style.setProperty('--option-color-image', `url(${optionValue})`);
                        swatch.style.setProperty('--option-color', 'var(--bg-body)');
                      } else {
                        swatch.style.setProperty('--option-color', optionValue);
                      }
                    }
                  }
                }
                Promise.resolve().then(_ => step())
              }
            }
            step()
          })
      })
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this))
    }

    quickAdd(evt) {
      evt.preventDefault()
      if (this.quick_add.disabled) {
        return
      }
      this.quick_add.disabled = true
      this.quick_add.classList.add(this.loadingClass)
      this.quick_add.setAttribute('aria-disabled', true)

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript',
        },
      }

      let formData = new FormData(this.form)

      formData.append('id', this.quick_add.dataset.productId)
      formData.append('quantity', 1)
      formData.append(
        'sections',
        this.getSectionsToRender().map(section => section.section)
      )
      formData.append('sections_url', window.location.pathname)

      config.body = formData

      fetch(`${theme.routes.cart_add_url}`, config)
        .then(response => response.json())
        .then(response => {
          if (response.status) {
            return
          }
          this.renderContents(response)

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response,
          })
        })
        .catch(e => {
          console.error(e)
        })
        .finally(() => {
          this.quick_add.classList.remove(this.loadingClass)
          this.quick_add.removeAttribute('aria-disabled')
          this.quick_add.disabled = false
        })

      return false
    }
    getSectionsToRender() {
      return [
        {
          id: 'Cart',
          section: 'main-cart',
          selector: '.thb-cart-form',
        },
        {
          id: 'Cart-Drawer',
          section: 'cart-drawer',
          selector: '.cart-drawer',
        },
        {
          id: 'cart-drawer-toggle',
          section: 'cart-bubble',
          selector: '.thb-item-count',
        },
      ]
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach(section => {
        if (!document.getElementById(section.id)) {
          return
        }
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id)
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector)
        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer()
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState)
        }
      })

      if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc')
        document.getElementById('Cart-Drawer').classList.add('active')

        dispatchCustomEvent('cart-drawer:open')
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML
    }
  }
  customElements.define('product-card', ProductCard)
}
/**
 *  @class
 *  @function ProductCardSmall
 */
if (!customElements.get('product-card-small')) {
  class ProductCardSmall extends HTMLElement {
    constructor() {
      super()

      this.quick_add_enabled = this.classList.contains('quick-add-to-card--true')
      this.button = this.querySelector('button')
      this.id = this.dataset.id
      this.url = this.dataset.url
    }
    connectedCallback() {
      if (this.quick_add_enabled) {
        this.setEventListeners()
      }
    }
    setEventListeners() {
      this.button.addEventListener('click', this.addToCart.bind(this))
    }
    getSectionsToRender() {
      return [
        {
          id: 'Cart',
          section: 'main-cart',
          selector: '.thb-cart-form',
        },
        {
          id: 'Cart-Drawer',
          section: 'cart-drawer',
          selector: '.cart-drawer',
        },
        {
          id: 'cart-drawer-toggle',
          section: 'cart-bubble',
          selector: '.thb-item-count',
        },
      ]
    }

    addToCart() {
      this.button.classList.add('loading')
      this.button.setAttribute('aria-disabled', true)

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript',
        },
      }

      let formData = new FormData(this.form)

      formData.append('id', this.id)
      formData.append('quantity', 1)
      formData.append(
        'sections',
        this.getSectionsToRender().map(section => section.section)
      )
      formData.append('sections_url', window.location.pathname)

      config.body = formData

      fetch(`${theme.routes.cart_add_url}`, config)
        .then(response => response.json())
        .then(response => {
          if (response.status) {
            return
          }

          this.renderContents(response)

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response,
          })
        })
        .catch(e => {
          console.error(e)
        })
        .finally(() => {
          this.button.classList.remove('loading')
          this.button.removeAttribute('aria-disabled')
        })
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach(section => {
        if (!document.getElementById(section.id)) {
          return
        }
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id)
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector)

        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer()
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState)
        }
      })
      if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc')
        document.getElementById('Cart-Drawer').classList.add('active')
        dispatchCustomEvent('cart-drawer:open')
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML
    }
  }
  customElements.define('product-card-small', ProductCardSmall)
}

/**
 *  @class
 *  @function PanelClose
 */
class PanelClose extends HTMLElement {
  constructor() {
    super()
    let cc = document.querySelector('.click-capture')

    // Add functionality to buttons
    this.addEventListener('click', e => this.close_panel(e))
    document.addEventListener('keyup', e => {
      if (e.code) {
        if (e.code.toUpperCase() === 'ESCAPE') {
          document.querySelectorAll('.side-panel').forEach(panel => {
            if (document.body.classList.contains('open-cc--product')) {
              document.body.classList.remove('open-cc--product')
              document.querySelector('#Product-Drawer-Content').innerHTML = ''
            } else {
              if (panel.classList.contains('cart-drawer')) {
                document.getElementById('cart-drawer-toggle').focus()
              }
              document.body.classList.remove('open-cc')
            }
            this.dispatchCloseEvent(panel)
            panel.classList.remove('active')
          })
        }
      }
    })
    cc.addEventListener('click', e => {
      let panel = document.querySelector('.side-panel.active')
      if (panel) {
        this.dispatchCloseEvent(panel)
        panel.classList.remove('active')
        document.body.classList.remove('open-cc')
      }
    })
  }

  dispatchCloseEvent(panel) {
    if (!panel || !panel.classList.contains('cart-drawer')) {
      return
    }
    dispatchCustomEvent('cart-drawer:close')
  }

  close_panel(e) {
    e.preventDefault()
    let panel = e.target.closest('.side-panel')
    this.dispatchCloseEvent(panel)
    panel.classList.remove('active')
    if (document.body.classList.contains('open-cc--product')) {
      document.body.classList.remove('open-cc--product')
      document.querySelector('#Product-Drawer-Content').innerHTML = ''
    } else {
      document.body.classList.remove('open-cc')
    }
  }
}
customElements.define('side-panel-close', PanelClose)

/**
 *  @class
 *  @function CartDrawer
 */
class CartDrawer {
  constructor() {
    this.container = document.getElementById('Cart-Drawer')

    if (!this.container) {
      return
    }
    // prevent duplicated event listeners
    if (this.container.dataset.initialized === 'true') {
      return
    }
    this.container.setAttribute('data-initialized', 'true')
    const button = document.getElementById('cart-drawer-toggle')
      // quantities = this.container.querySelectorAll('.quantity input'),
      // checkout_button = this.container.querySelector('.button.checkout')
    button?.addEventListener('click', e => {
      e.preventDefault()
      document.body.classList.add('open-cc')
      this.container.classList.add('active')
      this.container.focus()
      dispatchCustomEvent('cart-drawer:open')
    })

    this.debouncedOnChange = debounce(event => {
      this.onChange(event)
    }, 300)

    this.container.addEventListener('change', this.debouncedOnChange)

    this.notesToggle()
    this.removeProductEvent()
    // Terms checkbox
    this.termsCheckbox()
  }
  onChange(event) {
    if (event.target.classList.contains('qty')) {
      this.updateQuantity(event.target.dataset.index, event.target.value)
    }
  }
  removeProductEvent() {
    this.container.addEventListener('click', evt => {
      const target = evt.target.closest('.remove')
      if (target && evt.currentTarget.contains(target)) {
        evt.preventDefault()
        this.updateQuantity(target.dataset.index, '0')
      }
    })
  }
  getSectionsToRender() {
    return [
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer',
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count',
      },
    ]
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML
  }
  termsCheckbox() {
    let terms_checkbox = this.container.querySelector('#CartDrawerTerms'),
      checkout_button = this.container.querySelector('.button.checkout')

    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms)
      checkout_button.addEventListener('click', function (e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity()
          terms_checkbox.focus()
          e.preventDefault()
        }
      })
    }
  }
  notesToggle() {
    let notes_toggle = document.getElementById('order-note-toggle')

    if (!notes_toggle) {
      return
    }

    notes_toggle.addEventListener('click', event => {
      notes_toggle.nextElementSibling.classList.add('active')
    })
    notes_toggle.nextElementSibling.addEventListener('click', (evt) => {
      if (evt.target.closest('.button, .order-note-toggle__content-overlay')) {
        notes_toggle.nextElementSibling.classList.remove('active')
        this.saveNotes()
      }
    })
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: `application/json`,
      },
      body: JSON.stringify({
        note: document.getElementById('mini-cart__notes').value,
      }),
    })
  }
  updateQuantity(line, quantity) {
    this.container.querySelector(`#CartDrawerItem-${line}`).classList.add('thb-loading')
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map(section => section.section),
      sections_url: window.location.pathname,
    })

    dispatchCustomEvent('line-item:change:start', {
      quantity: quantity,
    })
    fetch(`${theme.routes.cart_change_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: `application/json`,
      },
      body,
    })
      .then(response => response.text())
      .then(state => {
        const parsedState = JSON.parse(state)

        this.getSectionsToRender().forEach(section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id)

          if (parsedState.sections) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            )
          }
        })
        // this.removeProductEvent()
        // this.notesToggle()
        // this.termsCheckbox()
        dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: parsedState,
        })
        if (this.container.querySelector(`#CartDrawerItem-${line}`)) {
          this.container.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading')
        }
      })
  }
}

/**
 *  @class
 *  @function ModalDialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super()
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this))
    this.addEventListener('keyup', event => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide()
    })
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', event => {
        if (event.pointerType === 'mouse' && !event.target.closest('product-model')) this.hide()
      })
    } else {
      this.addEventListener('click', event => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide()
      })
    }
  }

  connectedCallback() {
    if (this.moved) return
    this.moved = true
    document.body.appendChild(this)
  }

  show(opener) {
    this.openedBy = opener
    document.body.classList.add('overflow-hidden')
    this.setAttribute('open', '')
    if (this.dataset.autoPlay === 'true') {
      const videos = this.querySelectorAll('video');
      setTimeout(() => {
        videos.forEach(video => {
          if (video.paused) { video.play() } })
      })
    }
  }

  hide() {
    document.body.classList.remove('overflow-hidden')
    this.removeAttribute('open')
    this.querySelectorAll('.js-youtube').forEach(video => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*')
    })
    this.querySelectorAll('.js-vimeo').forEach(video => {
      video.contentWindow.postMessage('{"method":"pause"}', '*')
    })
    this.querySelectorAll('video').forEach(video => {
      video.pause()
      video.currentTime = 0
    })
  }
}
customElements.define('modal-dialog', ModalDialog)

class ModalOpener extends HTMLElement {
  constructor() {
    super()
    const button = this.querySelector('button');
    if (!button) return
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'))
      if (modal) modal.show(button)
    })
  }
}
customElements.define('modal-opener', ModalOpener)

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    // resize on initial load
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(this.resizeSelect)
    })

    document.body.addEventListener('change', e => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        this.resizeSelect(e.target)
      }
    })
    window.addEventListener('resize.resize-select', () => {
      document.querySelectorAll('.resize-select').forEach(this.resizeSelect)
    })
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option')
    tempOption.textContent = sel.selectedOptions[0].textContent

    let tempSelect = document.createElement('select')
    tempSelect.style.visibility = 'hidden'
    tempSelect.style.position = 'fixed'
    tempSelect.appendChild(tempOption)

    sel.after(tempSelect)
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + 12}px`
    }
    tempSelect.remove()
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth()
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    // resize on initial load
    document.querySelector('#footer')?.addEventListener('click', evt => {
      const button = evt.target.closest('.thb-widget-title.collapsible')
      if (button && evt.currentTarget.contains(button)) {
        button.classList.toggle('active')
      }
    })
  }
}

/**
 *  @class
 *  @function CustomSelect
 */
if (!customElements.get('custom-select')) {
  class CustomSelect extends HTMLElement {
    constructor() {
      super()
      this.detailsements = {
        form: this.closest('form'),
        input: this.querySelector('input'),
        button: this.querySelector('.custom-select--button'),
        panel: this.querySelector('.custom-select--list'),
      }
      this.autoClose = this.dataset.autoClose
      this.detailsements.button.addEventListener('click', this.toggleSelector.bind(this))
      this.detailsements.button.addEventListener('focusout', this.closeSelector.bind(this))
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this))

      this.detailsements.panel && this.detailsements.panel
        .querySelectorAll('button')
        .forEach(item => item.addEventListener('click', this.onItemClick.bind(this)))
    }

    hidePanel() {
      this.detailsements.button.setAttribute('aria-expanded', 'false')
      const section = this.closest('.shopify-section');
      if (section) section.style.zIndex = 52;
      this.classList.remove('custom-select--active')
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return

      this.hidePanel()
      this.detailsements.button.focus()
    }

    onItemClick(event) {
      event.preventDefault()
      this.detailsements.input.value = event.currentTarget.dataset.value
      this.detailsements.input.dispatchEvent(new Event('change'))
      this.detailsements.button.querySelector('.custom-select--text').textContent = event.currentTarget.textContent
      
      // 检查是否在 facet-filters-form 中
      const facetFormElement = this.closest('facet-filters-form');
      if (facetFormElement) {
        // 获取当前 URL 中的参数（包含已选择的过滤条件）
        const urlParams = new URLSearchParams(window.location.search);
        
        // 获取表单数据（包含 sort_by）
        const formData = new FormData(this.detailsements.form);
        
        // 定义单选字段列表（这些字段在表单中有值时，不保留 URL 中的旧值）
        const singleSelectFields = ['sort_by', 'q', 'options[prefix]'];
        
        // 将 URL 参数添加到表单数据中
        urlParams.forEach((value, key) => {
          // 获取表单中该参数的所有值
          const formValues = formData.getAll(key);
          
          // 如果是多选字段（以 filter.v. 开头），继承 URL 中的值（支持增减）
          if (key.startsWith('filter.v.')) {
            if (!formValues.includes(value)) {
              formData.append(key, value);
            }
            return;
          }
          
          // 如果是单选字段，表单中的值应该覆盖 URL 中的值，跳过添加
          if (singleSelectFields.includes(key) && formValues.length > 0) {
            return;
          }
          
          // 其他字段，添加不在表单中的值
          if (!formValues.includes(value)) {
            formData.append(key, value);
          }
        });
        
        const searchParams = new URLSearchParams(formData);
        
        // 调用 FacetFiltersForm.renderPage 处理
        if (typeof FacetFiltersForm !== 'undefined' && typeof FacetFiltersForm.renderPage === 'function') {
          FacetFiltersForm.renderPage(searchParams.toString(), event);
        } else if (this.detailsements.form) {
          // 如果 FacetFiltersForm 不可用，直接提交表单
          this.detailsements.form.dispatchEvent(new Event('input'));
          this.detailsements.form.submit();
        }
      } else if (this.detailsements.form) {
        // 如果不在 facet-filters-form 中，直接提交表单
        this.detailsements.form.dispatchEvent(new Event('input'));
        this.detailsements.form.submit();
      }
      
      if (this.autoClose) {
        this.classList.remove('custom-select--active');
      }
    }

    toggleSelector(event) {
      event.preventDefault()
      this.classList.toggle('custom-select--active')
      if (this.classList.contains('custom-select--active')) {
        // only change zindex for secondary menu
        const section = this.closest('.shopify-section.header-secondary-menu-section');
        if (section) section.style.zIndex = 54;
        this.detailsements.button.focus()
        this.detailsements.button.setAttribute(
          'aria-expanded',
          (this.detailsements.button.getAttribute('aria-expanded') === 'false').toString()
        )
      } else {
        this.hidePanel()
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.classList.contains('custom-select--button')
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel()
      }
    }
  }
  customElements.define('custom-select', CustomSelect)
}
/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super()
      this.debouncedOnSubmit = debounce(event => {
        this.onSubmitHandler(event)
      }, 200)
      this.form = this.querySelector('form')
      this.form.addEventListener('change', evt => {
        if (evt.target.closest('input[name="locale_code"], input[name="country_code"]')) {
          this.debouncedOnSubmit(evt)
        }
      })
    }
    onSubmitHandler(event) {
      if (this.form) this.form.submit()
    }
  }
  customElements.define('localization-form', LocalizationForm)
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    connectedCallback() {
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel')
      this.setupButtonObservers()
    }
    setupButtonObservers() {
      this.buttons = this.querySelectorAll('button')
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', e => {
          this.toggleActiveClass(i)
        })
      })
    }
    toggleActiveClass(i) {
      this.buttons.forEach(button => {
        button.classList.remove('tab-active')
      })
      this.buttons[i].classList.add('tab-active')

      this.panels.forEach(panel => {
        panel.classList.remove('tab-active')
      })
      this.panels[i].classList.add('tab-active')
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs)
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super()

      this.details = this.querySelector('details')
      this.summary = this.querySelector('summary')
      this.content = this.querySelector('.collapsible__content')

      this.animation = null
      this.isClosing = false
      this.isExpanding = false
    }
    connectedCallback() {
      this.setListeners()
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', e => this.onClick(e))
    }
    prepareAnimations() {
      let _this = this,
        summary_height = this.querySelector('summary').offsetHeight,
        content_height = this.querySelector('.collapsible__content').offsetHeight,
        initial_height = summary_height,
        final_height = summary_height + content_height

      this.tl = false
      this.tl = gsap.timeline({
        reversed: !_this.details.open,
        paused: true,
        inherit: false,
        ease: 'none',
        onStart: function () {
          _this.details.open = true
          _this.details.style.overflow = 'hidden'
        },
        onReverseComplete: function () {
          _this.details.open = false
          _this.details.style.overflow = ''
        },
      })

      this.tl.fromTo(
        _this.details,
        {
          height: function () {
            let h = Math.max(Math.max(initial_height, 0), 24)
            return h
          },
          clearProps: 'height',
        },
        {
          duration: 0.4,
          height: final_height,
          clearProps: 'height',
        }
      )

      if (this.details.open) {
        this.tl.progress(1)
      }
    }
    instantClose() {
      this.tl.timeScale(10).reverse()
    }
    animateClose() {
      this.tl.timeScale(3).reverse()
    }
    animateOpen() {
      this.tl.timeScale(1).play()
    }
    onClick(e) {
      e.preventDefault()
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden'
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open()
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink()
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel()
      }

      // Start a WAAPI animation
      this.animation = this.details.animate(
        {
          // Set the keyframes from the startHeight to endHeight
          height: [startHeight, endHeight],
        },
        {
          duration: 250,
          easing: 'ease',
        }
      )

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false)
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => (this.isClosing = false)
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`
      // Force the [open] attribute on the details element
      this.details.open = true
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand())
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`

      // If there is already an animation running
      if (this.animation) {
        this.animation.cancel()
      }

      // Start a WAAPI animation
      this.animation = this.details.animate(
        {
          // Set the keyframes from the startHeight to endHeight
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: 'ease-out',
        }
      )
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true)
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => (this.isExpanding = false)
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open
      // Clear the stored animation
      this.animation = null
      // Reset isClosing & isExpanding
      this.isClosing = false
      this.isExpanding = false
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = ''
    }
  }
  customElements.define('collapsible-row', CollapsibleRow)
}

/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
  fetchProducts(isFallback = false) {
    let url = this.dataset.url
    const urlObj = new URL(/^\//.test(url) ? window.location.origin + url : url)
    if (isFallback) {
      urlObj.searchParams.set('intent', 'related')
      url = urlObj.toString()
    }
    // product id required https://shopify.dev/docs/api/ajax/reference/product-recommendations
    if (!urlObj.searchParams.get('product_id')) return
    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div')
        html.innerHTML = text
        const recommendations = html.querySelector('product-recommendations')

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML
          this.classList.add('product-recommendations--loaded')
        } else if (!isFallback) {
          this.fetchProducts(true)
        }
      })
      .catch(e => {
        console.error(e)
      })
  }
  connectedCallback() {
    this.fetchProducts()
  }
}

customElements.define('product-recommendations', ProductRecommendations)

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    connectedCallback() {
      this.cc = document.querySelector('.click-capture--product')
      this.drawer = document.getElementById('Product-Drawer')
      this.body = document.body

      this.addEventListener('click', this.setupEventListener.bind(this))
      this.cc.addEventListener('click', this.setupCCEventListener.bind(this))
    }
    setupCCEventListener(e) {
      this.body.classList.remove('open-cc--product')
      this.drawer.classList.remove('active')
      this.drawer.querySelector('#Product-Drawer-Content').innerHTML = ''
    }
    setupEventListener(e) {
      e.preventDefault()
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/')
      if (!href || !productHandle) {
        return
      }
      if (this.classList.contains('loading')) {
        return
      }
      this.classList.add('loading')
      fetch(href, { method: 'GET' })
        .then(response => {
          this.classList.remove('loading')
          return response.text()
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML

          this.renderQuickview(sectionInnerHTML, href, productHandle)
        })
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {
        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script')

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0]
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script')
            script.src = js_file.src
            head.appendChild(script)
          })
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init()
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR()
          }
        }, 300)

        this.body.classList.add('open-cc--product')
        this.drawer.classList.add('active')

        this.drawer.querySelector('.side-panel-close').focus()

        setTimeout(() => {
          let slider = this.drawer.querySelector('#Product-Slider'),
            flkty = Flickity.data(slider)

          flkty.reposition()
        }, 100)
        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle,
        })
      }
    }
  }
  customElements.define('quick-view', QuickView)
}

if (!customElements.get('flash-sales-countdown')) {
  customElements.define('flash-sales-countdown', class extends HTMLElement {
    tId = 0;
    endsAt = null;
    locales = null;
    connectedCallback() {
      const endsAt = this.getAttribute('ends-at');
      const hideUntilNDays = this.getAttribute('hide-until-n-days');
      const date = new Date(endsAt);
      try { this.locales = JSON.parse(atob(this.getAttribute('locales'))) } catch { /* discard */ }
      if (hideUntilNDays) {
        const now = new Date();
        const nDaysInMs = parseInt(hideUntilNDays, 10) * 24 * 60 * 60 * 1000;
        const hideUntil = new Date(date.getTime() - nDaysInMs);
        if (now < hideUntil) return
      }
      if (date) {
        this.endsAt = date
        this.start()
      }
    }

    start() {
      clearTimeout(this.tId)
      const endsAt = this.endsAt
      const timeout = 1000
      function padZero(num) {
        return ('00'+num.toString()).slice(-2)
      }
      const template = this.querySelector('template')
      /** @type {HTMLElement} */
      const root = template.content.cloneNode(true)
      const daysEl = root.querySelector('.days .countdown-timer--column--number')
        ?.attachShadow({ mode: 'open' }).appendChild(document.createElement('span'))
      const hoursEl = root.querySelector('.hours .countdown-timer--column--number')
        ?.attachShadow({ mode: 'open' }).appendChild(document.createElement('span'))
      const minutesEl = root.querySelector('.minutes .countdown-timer--column--number')
        ?.attachShadow({ mode: 'open' }).appendChild(document.createElement('span'))
      const secondsEl = root.querySelector('.seconds .countdown-timer--column--number')
        ?.attachShadow({ mode: 'open' }).appendChild(document.createElement('span'))
      const update = () => {
        const endsAtTime = endsAt.getTime()
        const now = Date.now()
        const distance = endsAtTime - now
        if (distance < 0) {
          this.parentElement.removeChild(this)
          return
        } else {
          const days = Math.min(99, Math.floor(distance / (1000 * 60 * 60 * 24)));
          const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);
          try {
            daysEl.innerText = padZero(days)
            hoursEl.innerText = padZero(hours)
            minutesEl.innerText = padZero(minutes)
            secondsEl.innerText = padZero(seconds)
          } catch {}
          if (days < 1) {
            root.querySelector('.days .countdown-timer--column--number')?.setAttribute('hidden', '')
            root.querySelector('.days .countdown-timer--column--text')?.setAttribute('hidden', '')
          } else {
            if (days === 1 && this.locales && this.locales.day) {
              const textEl = root.querySelector('.days .countdown-timer--column--text');
              if (textEl) { textEl.innerText = this.locales.day }
            }
          }
        }
        this.tId = setTimeout(update, timeout)
      }
      if (endsAt) {
        update()
        this.appendChild(root)
      }
    }
  })
}

/**
 *  @class
 *  @function AnimatedMarkers
 */
class AnimatedMarkers {
  constructor() {
    this.markers = document.querySelectorAll('.svg-marker path')
    this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined'

    if (this.animations_enabled && this.markers.length) {
      this.setupEventListeners()
    }
  }
  setupEventListeners() {
    this.markers.forEach((marker, i) => {
      gsap.from(marker, {
        duration: 1,
        ease: 'power4.inOut',
        drawSVG: '0%',
        scrollTrigger: {
          trigger: marker,
          start: 'top 70%',
          end: 'bottom 80%',
        },
      })
    })
  }
}
document.addEventListener('DOMContentLoaded', () => {
  // fix wrong horizontal scroll
  document.documentElement.scrollLeft = 0;
  if (typeof CartDrawer !== 'undefined') {
    new CartDrawer()
  }
  if (typeof AnimatedMarkers !== 'undefined') {
    new AnimatedMarkers()
  }
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle()
  }
  try {
    if (Shopify.theme.role !== 'main') { document.body.classList.add('is-not-main') }
  } catch { /** NOOP */}
});

/** 
* Bundle page navigation
*/

const navItems = document.querySelectorAll('.bundle_nav-items');

navItems.forEach(function(nav) {
  const links = nav.querySelectorAll('a');

  links.forEach(function(link) {
    link.addEventListener('click', function() {
      links.forEach(function(otherLink) {
        otherLink.classList.remove('active');
      });

      this.classList.add('active');

      
      document.querySelector(".bundle_nav-items--mobile").scrollTo({
        left: (this.offsetLeft + this.clientWidth / 2) - document.body.clientWidth / 2,
        behavior: "smooth"
      });
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var selectedFlickity = {}
  window.addEventListener('scroll', debounce(() => {
    const s = document.querySelector(".bundle_nav-items--mobile .bundle_nav-items__cell.active")
    if(selectedFlickity != s){
      selectedFlickity = s
      document.querySelector(".bundle_nav-items--mobile")?.scrollTo({
        left: (selectedFlickity.offsetLeft + selectedFlickity.clientWidth / 2) - document.body.clientWidth / 2,
        behavior: "smooth"
      });
    }
  }, 300), {
     passive: true
  });
});

  document.querySelectorAll('.feature-chart--mobile-button').forEach(function (el) {
    let hides = el.closest('.feature-chart').querySelectorAll('.more-item')
    let button = el.querySelector('.button-title')
    el.addEventListener('click', e => {
      if (button.innerText == el.getAttribute('data-view-more')) {
        hides.forEach(item => {
          item.classList.remove('mobile-hide')
        })
        button.innerText = el.getAttribute('data-view-less')
      } else {
        hides.forEach(item => {
          item.classList.add('mobile-hide')
        })
        button.innerText = el.getAttribute('data-view-more')
      }
    })
  })
  document.querySelectorAll('.revy-bundle-wrapper-inner').forEach(function (e) {
    let original = e.querySelector('.original-price span').innerText
    let current = e.querySelector('.current-price span').innerText
    let money = original.charAt(0)
    e.querySelector('.original-price span').innerText =
      original.charAt(0) + (parseInt(original.replace(money, '')) + parseInt(current.replace(money, '')))
  })

// Sticky Nav
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.sticky-navigation')) {
    let sticky_bar_height = 0;
    let offset = 300;
    let linkClicked = false;

    const nav = document.querySelector('.bundle_nav-items');

    const scrollOffset = nav.getAttribute('data-scroll-offset');

    const links_desktop = document.querySelectorAll('.bundle_nav-items--desktop a');
    const links_mobile = document.querySelectorAll('.bundle_nav-items--mobile a');

    updateOnClickStickyNavState(links_desktop);
    updateOnClickStickyNavState(links_mobile);

    window.onscroll = function () {
      const scrollPos_start = window.scrollY + sticky_bar_height + offset;
      const scrollPos_end = window.scrollY + sticky_bar_height;

      if (!linkClicked) {
        updateStickyNavState(links_desktop, scrollPos_start);
        updateStickyNavState(links_mobile, scrollPos_start);
      }
    };

    function updateOnClickStickyNavState(links) {
      links.forEach(function (e) {
        var section_id = (e.getAttribute('href') == '#' ? '#no-valid-selector' : e.getAttribute('href')) || '';
        var section_id_trans = section_id.toLowerCase().replace(/\s+/g, '-').replace(/[^-a-zA-Z0-9]/g, '')
        if (!section_id) return

        var refElement
        try {
          refElement = document.querySelector(section_id)
        } catch {
          refElement = document.querySelector(`[id="${section_id.replace('#', '')}"]`) || document.querySelector(section_id_trans)
        }

        if (refElement) {
          e.onclick = function (evt) {
            evt.preventDefault();
            
            linkClicked = true;

            var section_top = refElement.getBoundingClientRect().top + window.scrollY - sticky_bar_height - scrollOffset;

            setTimeout(function () {
              window.scroll({
                top: section_top,
                behavior: 'smooth',
              });
            }, 100);

            setTimeout(function () {
              linkClicked = false;
            }, 1000);
          };
        }
      });
    }

    function updateStickyNavState(links, scrollPos_start) {
      links.forEach(function (e) {
        var section_id = (e.getAttribute('href') == '#' ? '#no-valid-selector' : e.getAttribute('href')) || '';
        var section_id_trans = section_id.toLowerCase().replace(/\s+/g, '-').replace(/[^-a-zA-Z0-9]/g, '');
        if (!section_id) return

        var refElement
        try {
          refElement = document.querySelector(section_id)
        } catch {
          refElement = document.querySelector(`[id="${section_id.replace('#', '')}"]`) || document.querySelector(section_id_trans)
        }
        if (refElement) {
          const section_top = refElement.getBoundingClientRect().top + window.scrollY;

          if (scrollPos_start >= section_top) {
            links.forEach(function (link) {
              if (link !== e) {
                link.classList.remove('active');
              }
            });

            e.classList.add('active');
          }
        }
      });
    }
  }
});


/**
 *  @class
 *  @function CollapsiblePanel
 */
if (!customElements.get('collapsible-panel')) {
  class CollapsiblePanel extends HTMLElement {
    static get observedAttributes() {
      return [
        'collapsible',
        'data-collapsible',
        'collapse-height',
        'data-collapse-height',
        'collapse-threshold',
        'data-collapse-threshold',
        'data-collapsible-threshold',
      ]
    }
    constructor() {
      super()
      this.animation = null
      this.toggle = null
      this.panelContent = null
      this.isInteractive = false
      this.panelExpanded = false

      this.resizeObserver = null

      this.onToggleClick = e => this.handleToggleClick(e)
    }
    connectedCallback() {
      this.formatMetafieldText()
      this.cacheElements()
      this.setListeners()
      this.setupResizeObserver()
      this.refresh()
    }
    formatMetafieldText() {
      const metafields = Array.from(this.querySelectorAll('.metafield-rich_text_field'))
      for (let el of metafields) {
        el.innerHTML = el.innerHTML.replace(/&nbsp;/g, ' ')
      }
    }
    disconnectedCallback() {
      if (this.toggle) this.toggle.removeEventListener('click', this.onToggleClick)
      if (this.resizeObserver) this.resizeObserver.disconnect()
      if (this.animation) this.animation.cancel()
    }
    attributeChangedCallback() {
      this.refresh()
    }
    cacheElements() {
      this.toggle = this.querySelector('[data-collapsible-toggle]')
      this.panelContent = this.querySelector('[data-collapsible-content]')
    }
    setListeners() {
      if (this.toggle && this.panelContent) {
        this.toggle.addEventListener('click', this.onToggleClick)
      }
    }
    setupResizeObserver() {
      if (typeof ResizeObserver === 'undefined') return
      const target = this.panelContent
      if (!target) return
      this.resizeObserver = new ResizeObserver(() => this.refresh())
      this.resizeObserver.observe(target)
    }
    getCollapsibleEnabled() {
      const raw = this.getAttribute('collapsible') ?? this.getAttribute('data-collapsible')
      if (raw == null) return true
      const value = String(raw).trim().toLowerCase()
      if (value === '' || value === 'true' || value === '1' || value === 'yes') return true
      if (value === 'false' || value === '0' || value === 'no') return false
      return true
    }
    getCollapseHeightPx(defaultValue = 0) {
      const raw =
        this.getAttribute('collapse-height') ??
        this.getAttribute('data-collapse-height') ??
        this.getAttribute('collapse-threshold') ??
        this.getAttribute('data-collapse-threshold') ??
        this.getAttribute('data-collapsible-threshold')
      if (raw == null) return defaultValue
      const parsed = Number.parseInt(String(raw), 10)
      return Number.isFinite(parsed) ? Math.max(parsed, 0) : defaultValue
    }
    refresh() {
      const collapsibleEnabled = this.getCollapsibleEnabled()

      if (this.toggle && this.panelContent) {
        const collapseHeightPx = this.getCollapseHeightPx(0)
        const contentHeight = this.panelContent.scrollHeight
        this.isInteractive = collapsibleEnabled && collapseHeightPx > 0 && contentHeight > collapseHeightPx
        this.updatePanelMode()
      }
    }
    updatePanelMode() {
      if (!this.toggle || !this.panelContent) return

      if (!this.isInteractive) {
        if (this.animation) this.animation.cancel()
        this.toggle.hidden = true
        this.toggle.setAttribute('aria-expanded', 'true')
        this.panelContent.style.height = this.panelContent.style.overflow = ''
        this.panelExpanded = true
        return
      }

      this.toggle.hidden = false
      if (!this.toggle.hasAttribute('aria-expanded')) {
        this.panelExpanded = false
        this.toggle.setAttribute('aria-expanded', 'false')
      } else {
        this.panelExpanded = this.toggle.getAttribute('aria-expanded') === 'true'
      }

      if (this.panelExpanded) {
        this.panelContent.style.height = this.panelContent.style.overflow = ''
      } else {
        const collapseHeightPx = this.getCollapseHeightPx(0)
        this.panelContent.style.height = `${collapseHeightPx}px`
        this.panelContent.style.overflow = 'hidden'
      }

      this.syncToggleLabel()
    }
    handleToggleClick(e) {
      e.preventDefault()
      if (!this.isInteractive) return

      if (this.panelExpanded) {
        this.animatePanelCollapse()
      } else {
        this.animatePanelExpand()
      }
    }
    animatePanelCollapse() {
      const collapseHeightPx = this.getCollapseHeightPx(0)
      const startHeight = `${this.panelContent.offsetHeight}px`
      const endHeight = `${collapseHeightPx}px`

      if (this.animation) this.animation.cancel()

      this.panelContent.style.overflow = 'hidden'
      this.animation = this.panelContent.animate(
        { height: [startHeight, endHeight] },
        { duration: 250, easing: 'ease' }
      )

      this.animation.onfinish = () => {
        this.panelExpanded = false
        this.animation = null
        this.panelContent.style.height = endHeight
        this.panelContent.style.overflow = 'hidden'
        this.toggle.setAttribute('aria-expanded', 'false')
        this.syncToggleLabel()
      }
      this.animation.oncancel = () => {}
    }
    animatePanelExpand() {
      const startHeight = `${this.panelContent.offsetHeight}px`

      this.panelContent.style.height = startHeight
      this.panelContent.style.overflow = 'hidden'

      const endHeight = `${this.panelContent.scrollHeight}px`

      if (this.animation) this.animation.cancel()

      this.animation = this.panelContent.animate(
        { height: [startHeight, endHeight] },
        { duration: 400, easing: 'ease-out' }
      )

      this.animation.onfinish = () => {
        this.panelExpanded = true
        this.animation = null
        this.panelContent.style.height = this.panelContent.style.overflow = ''
        this.toggle.setAttribute('aria-expanded', 'true')
        this.syncToggleLabel()
      }
      this.animation.oncancel = () => {}
    }
    syncToggleLabel() {
      if (!this.toggle) return
      const more = this.toggle.getAttribute('data-label-more')
      const less = this.toggle.getAttribute('data-label-less')
      if (!more || !less) return
      this.toggle.textContent = this.panelExpanded ? less : more
    }
  }

  customElements.define('collapsible-panel', CollapsiblePanel)
}

/**
 *  @class
 *  @function drag-scroll
 */
if (!customElements.get('drag-scroll')) {
  class DragScroll extends HTMLElement {
    constructor() {
      super();
      this.isDragging = false;
      this.startX = 0;
      this.scrollLeft = 0;
      this.unbindEvents = null;
    }

    throttle(callback) {
      let id = null;
      return (e) => {
        if (id) return;
        id = requestAnimationFrame(() => {
          callback(e);
          id = null;
        });
      };
    }

    // 元素挂载时绑定事件
    connectedCallback() {
      this.unbindEvents = this.bindEvents();
    }

    disconnectedCallback() {
      this.unbindEvents && this.unbindEvents();
    }

    bindEvents() {
      const el = this;

      const startDrag = (e) => {
        this.isDragging = true;
        el.classList.add('dragging');
        this.startX = e.x;
        this.scrollLeft = el.scrollLeft;
        if (e.pointerId != null && el.setPointerCapture) {
          try { el.setPointerCapture(e.pointerId); } catch {}
        }
        e.preventDefault();
      }

      const draging = this.throttle((e) => {
        if (!this.isDragging) return;
        e.preventDefault();
        const dx = e.x - this.startX;
        el.scrollLeft = this.scrollLeft - dx;
        this.startX = e.x;
      })

      const stopDrag = () => {
        if (!this.isDragging) return;
        this.isDragging = false;
        el.classList.remove('dragging');
        if (e && e.pointerId != null && el.releasePointerCapture) {
          try { el.releasePointerCapture(e.pointerId); } catch {}
        }
      };

      // 鼠标按下
      el.addEventListener('mousedown', startDrag);
      // 鼠标移动
      el.addEventListener('mousemove', draging);
      // 鼠标抬起 / 离开
      el.addEventListener('mouseup', stopDrag);
      // el.addEventListener('mouseleave', stopDrag);
      document.addEventListener('mouseup', stopDrag);
      document.addEventListener('mouseleave', stopDrag);

      // // 移动端触摸
      // el.addEventListener('touchstart', startDrag);
      // el.addEventListener('touchmove', draging);
      // el.addEventListener('touchend', stopDrag);
      // el.addEventListener('touchcancel', stopDrag);
      return () => {
        stopDrag();
        el.removeEventListener('mousedown', startDrag);
        el.removeEventListener('mousemove', draging);
        el.removeEventListener('mouseup', stopDrag);
        // el.removeEventListener('mouseleave', stopDrag);
        document.removeEventListener('mouseup', stopDrag);
        document.removeEventListener('mouseleave', stopDrag);
        // el.removeEventListener('touchstart', startDrag);
        // el.removeEventListener('touchmove', draging);
        // el.removeEventListener('touchend', stopDrag);
        // el.removeEventListener('touchcancel', stopDrag);
      };
    }
  }

  // 注册自定义元素
  customElements.define('drag-scroll', DragScroll);
}

/**
 *  @class
 *  @function dropdown-select
 *  
 * 用途：把原生 <select> 增强成可自定义样式的下拉组件（可选 swatch），并保持表单/事件语义（change/input）一致。
 *
 * 基础用法（纯 select，无 swatch，无 portal）：
 * ```html
 * <dropdown-select data-portal="none">
 *   <select class="my-select__select" aria-label="Choose one">
 *     <option value="a">Option A</option>
 *     <option value="b">Option B</option>
 *   </select>
 * </dropdown-select>
 * ```
 *
 * Swatch 用法（给 <option> 加 data-swatch-color 或 data-swatch-image）：
 * ```html
 * <dropdown-select>
 *   <select class="my-select__select">
 *     <option value="1" data-swatch-color="#000000">Black</option>
 *     <option value="2" data-swatch-image="https://.../img.png">Pattern</option>
 *   </select>
 * </dropdown-select>
 * ```
 *
 * 属性（挂在 <dropdown-select> 上）：
 * - data-bem="xxx"：指定 BEM block；内部元素会生成 xxx__trigger / xxx__menu / xxx__option... 类名
 *   - 不传时：优先从内部 select 的 xxx__select 自动推断；其次从宿主 class 推断；最终回退到 e-select
 * - data-portal="layer|none"：菜单是否提升到 body 的固定层（layer=fixed 定位；none=就地渲染）默认为none
 * - data-keep-native="true"：不隐藏原生 select（默认隐藏）
 * - data-swatch="true"：强制展示 swatch（默认仅当 option 存在 swatch 数据时才展示）
 * - data-avoid=".selector"：portal 定位时避让某个元素（用于计算最大可用高度）
 * - data-open-target="selector" + data-open-class="className"：打开菜单时给最近祖先加 class（用于提升 z-index 场景）
 *
 * 键盘支持：
 * - Trigger：Enter/Space 打开或关闭；↑/↓ 打开并移动焦点
 * - Menu：↑/↓/Home/End 导航；Enter/Space 选择；Esc 关闭；输入字母支持快速定位
 *
 * 事件语义：
 * - 点击自定义选项时会更新 select.value，并派发 bubbles=true 的 change 事件
 */
if (!customElements.get("dropdown-select")) {
  const ensureDropdownSelectBaseStyles = () => {
    const STYLE_ID = "dropdown-select-base-styles";
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = `
      dropdown-select{display:inline-block;position:relative}
      .dropdown-select__trigger{display:flex;align-items:center;justify-content:space-between;gap:8px;width:100%;padding:10px 12px;border:1px solid rgba(0,0,0,.18);border-radius:8px;background:#fff;color:inherit;font:inherit;line-height:1.2;cursor:pointer;-webkit-tap-highlight-color:transparent}
      .dropdown-select__trigger:focus{outline:2px solid rgba(0,0,0,.6);outline-offset:2px}
      .dropdown-select__trigger:focus:not(:focus-visible){outline:none}
      .dropdown-select__trigger:disabled{opacity:.5;cursor:not-allowed}
      .dropdown-select__text{flex:1;min-width:0;text-align:left;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
      .dropdown-select__icon{display:flex;align-items:center;justify-content:center;flex:0 0 auto;transition:transform .18s ease}
      dropdown-select.is-open .dropdown-select__icon{transform:rotate(180deg)}
      .dropdown-select__swatch{width:14px;height:14px;border-radius:50%;flex:0 0 auto;background:var(--option-color,transparent);background-image:var(--option-color-image);background-size:cover;background-position:center;border:1px solid rgba(0,0,0,.12)}
      .dropdown-select__menu{box-sizing:border-box;margin-top:8px;margin-bottom:8px;border:1px solid rgba(0,0,0,.06);border-radius:16px;background:#fff;box-shadow:0 4px 20px 0 rgba(0,0,0,.1);padding:4px;z-index:20;display:flex;flex-direction:column;gap:4px}
      .dropdown-select__menu:not(.is-fixed){position:absolute;top:100%;left:0;min-width:100%;}
      .dropdown-select__option{display:flex;align-items:center;gap:12px;width:100%;padding:8px 16px;border:0;border-radius:12px;background:transparent;color:inherit;font:inherit;line-height:1.2;text-align:left;cursor:pointer}
      .dropdown-select__option:hover{background:#F7F7F7}
      .dropdown-select__option:focus{outline:2px solid rgba(0,0,0,.6);outline-offset:2px}
      .dropdown-select__option:focus:not(:focus-visible){outline:none}
      .dropdown-select__option:disabled{opacity:.45;cursor:not-allowed}
      .dropdown-select__option.is-selected{background:#F7F7F7}
      .dropdown-select__option-swatch{width:32px;height:32px;border-radius:50%;flex:0 0 auto;background:var(--option-color,transparent);background-image:var(--option-color-image);background-size:cover;background-position:center;border:1px solid rgba(0,0,0,0.06)}
      .dropdown-select__option-label{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
      
      @media screen and (max-width: 767px) {
        .dropdown-select__option{padding: 10px 16px;}
        .dropdown-select__option-swatch{width:28px;height:28px;}
      }
    `;
    document.head.appendChild(style);
  };

  class DropdownSelect extends HTMLElement {
    constructor() {
      super();
      this.positionRaf = 0;
      this.positionIdle = 0;
      this.refreshRaf = 0;
      this.typeaheadTimer = 0;
      this.typeaheadBuffer = "";
      this.typeaheadTs = 0;
      this.rendered = false;
      this.opened = false;
      this.abort = null;
      this.observer = null;
      this.uid = "";
      this.onTriggerClick = () => {
        if (!this.menu) return;
        if (this.menu.hidden) this.open();
        else this.close({ focusTrigger: true });
      };
      this.onDocPointer = (e) => {
        if (!this.isConnected) return;
        if (!this.menu || this.menu.hidden) return;
        const t = e.target;
        if (this.contains(t) || this.menu.contains(t)) return;
        this.close();
      };
      this.onDocKey = (e) => {
        if (e.key !== "Escape") return;
        this.close({ focusTrigger: true });
      };
      this.onWinUpdate = () => {
        if (!this.opened) return;
        this.schedulePositionMenu();
      };
      this.onSelectChange = () => this.refresh({ populate: false });
      this.onSelectInput = () => this.refresh({ populate: false });
      this.onTriggerKeydown = (e) => this.handleTriggerKeydown(e);
      this.onMenuKeydown = (e) => this.handleMenuKeydown(e);
    }
    connectedCallback() {
      ensureDropdownSelectBaseStyles();
      this.select = this.querySelector("select");
      if (!this.select) return;
      if (!this.uid) this.uid = this.getUid();
      this.setupConfig();
      if (!this.rendered) {
        this.build();
        this.rendered = true;
      }
      this.bind();
      this.refresh({ populate: true, force: true });
    }
    disconnectedCallback() {
      this.unbind();
      this.close();
      this.teardownPositioning();
      this.teardownPortal();
    }
    getUid() {
      if (typeof crypto !== "undefined" && crypto.randomUUID) {
        return `dropdown-select-${crypto.randomUUID()}`;
      }
      return `dropdown-select-${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
    }
    setupConfig() {
      const bem =
        this.getAttribute("data-bem") ||
        this.detectBemFromSelect() ||
        this.detectBemFromHost() ||
        "e-select";
      this.bem = bem;
      const portalRaw = this.getAttribute("data-portal");
      if (portalRaw == null) {
        this.portal = "none";
      } else {
        const v = String(portalRaw).toLowerCase();
        this.portal = v === "none" || v === "false" || v === "0" || v === "inline" ? "none" : "layer";
      }
      this.keepNative = this.getAttribute("data-keep-native") === "true";
      this.forceSwatch = this.getAttribute("data-swatch") === "true";
      this.avoidSelector = this.getAttribute("data-avoid");
      this.openClassTargetSelector = this.getAttribute("data-open-target");
      this.openClassName = this.getAttribute("data-open-class");
    }
    detectBemFromSelect() {
      if (!this.select) return "";
      const cls = Array.from(this.select.classList);
      const hit =
        cls.find((c) => c.endsWith("__select")) ||
        cls.find((c) => c.includes("__select"));
      if (!hit) return "";
      const idx = hit.indexOf("__select");
      if (idx <= 0) return "";
      return hit.slice(0, idx);
    }
    detectBemFromHost() {
      const cls = Array.from(this.classList).filter(
        (c) => !c.includes("__") && !c.startsWith("is-") && !c.startsWith("js-"),
      );
      return cls[0] || "";
    }
    cls(part) {
      return `${this.bem}__${part}`;
    }
    addPartClass(el, part) {
      if (!el) return;
      el.classList.add(this.cls(part));
      el.classList.add(`dropdown-select__${part}`);
    }
    build() {
      this.classList.add("dropdown-select");
      if (this.bem && !this.classList.contains(this.bem)) this.classList.add(this.bem);

      this.trigger = document.createElement("button");
      this.trigger.type = "button";
      this.addPartClass(this.trigger, "trigger");
      this.trigger.setAttribute("aria-haspopup", "listbox");
      this.trigger.setAttribute("aria-expanded", "false");

      this.swatch = document.createElement("span");
      this.addPartClass(this.swatch, "swatch");
      this.swatch.setAttribute("aria-hidden", "true");

      this.textEl = document.createElement("span");
      this.addPartClass(this.textEl, "text");

      const icon = document.createElement("span");
      this.addPartClass(icon, "icon");
      icon.setAttribute("aria-hidden", "true");
      icon.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M17.1646 11.2477C17.5773 10.8808 17.6145 10.2483 17.2476 9.83557C16.8807 9.42291 16.2482 9.38568 15.8355 9.75256L12 13.1622L8.16459 9.75256C7.75182 9.38576 7.11937 9.42285 6.75248 9.83557C6.38574 10.2483 6.42289 10.8808 6.83549 11.2477L11.3355 15.2477C11.7143 15.5844 12.2857 15.5843 12.6646 15.2477L17.1646 11.2477Z" fill="black" fill-opacity="0.44"/></svg>';

      this.trigger.appendChild(this.textEl);
      this.trigger.appendChild(icon);
      this.insertBefore(this.trigger, this.select);

      this.menu = document.createElement("div");
      this.addPartClass(this.menu, "menu");
      this.menu.setAttribute("role", "listbox");
      this.menu.id = `${this.uid}-listbox`;
      this.menu.hidden = true;
      this.appendChild(this.menu);

      if (!this.select.classList.contains(this.cls("select"))) this.select.classList.add(this.cls("select"));
      this.select.classList.add("dropdown-select__select");
      if (!this.keepNative) this.select.hidden = true;

      this.trigger.setAttribute("aria-controls", this.menu.id);
    }
    bind() {
      this.unbind();
      this.abort = typeof AbortController === "function" ? new AbortController() : null;
      const opt = this.abort ? { signal: this.abort.signal } : undefined;

      this.trigger.addEventListener("click", this.onTriggerClick, opt);
      this.trigger.addEventListener("keydown", this.onTriggerKeydown, opt);
      this.menu.addEventListener("keydown", this.onMenuKeydown, opt);

      this.select.addEventListener("change", this.onSelectChange, opt);
      this.select.addEventListener("input", this.onSelectInput, opt);

      const form = this.select.form;
      if (form) {
        form.addEventListener(
          "reset",
          () => {
            requestAnimationFrame(() => this.refresh({ populate: false }));
          },
          opt,
        );
      }

      document.addEventListener("pointerdown", this.onDocPointer, opt);
      document.addEventListener("keydown", this.onDocKey, opt);
      window.addEventListener("resize", this.onWinUpdate, opt);
      const scrollOpt = this.abort ? { signal: this.abort.signal, capture: true } : true;
      window.addEventListener("scroll", this.onWinUpdate, scrollOpt);

      if (typeof MutationObserver === "function") {
        this.observer = new MutationObserver(() => this.scheduleRefresh());
        this.observer.observe(this.select, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
        });
      }
    }
    unbind() {
      if (this.abort) {
        this.abort.abort();
        this.abort = null;
      } else {
        if (this.trigger) {
          this.trigger.removeEventListener("click", this.onTriggerClick);
          this.trigger.removeEventListener("keydown", this.onTriggerKeydown);
        }
        if (this.menu) this.menu.removeEventListener("keydown", this.onMenuKeydown);
        if (this.select) {
          this.select.removeEventListener("change", this.onSelectChange);
          this.select.removeEventListener("input", this.onSelectInput);
        }
        document.removeEventListener("pointerdown", this.onDocPointer);
        document.removeEventListener("keydown", this.onDocKey);
        window.removeEventListener("resize", this.onWinUpdate);
        window.removeEventListener("scroll", this.onWinUpdate, true);
      }
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
    scheduleRefresh() {
      if (this.refreshRaf) return;
      this.refreshRaf = requestAnimationFrame(() => {
        this.refreshRaf = 0;
        this.refresh({ populate: true });
      });
    }
    refresh({ populate = false, force = false } = {}) {
      if (!this.select || !this.trigger || !this.menu || !this.textEl) return;
      if (populate) this.populateMenu();
      this.syncFromSelect();
      this.syncSelected();
      if (force && this.opened) this.schedulePositionMenu({ force: true });
    }
    syncFromSelect() {
      const opt = this.select.options[this.select.selectedIndex];
      this.textEl.textContent = opt?.textContent || "";
      const disabled = !!this.select.disabled;
      this.trigger.disabled = disabled;
      this.trigger.setAttribute("aria-disabled", disabled ? "true" : "false");

      const hasSwatchData = Array.from(this.select.options).some(
        (o) => !!(o?.dataset?.swatchColor || o?.dataset?.swatchImage),
      );
      const showSwatch = this.forceSwatch || hasSwatchData;

      if (showSwatch) {
        if (!this.swatch.isConnected) this.trigger.insertBefore(this.swatch, this.trigger.firstChild);
        const c = opt?.dataset?.swatchColor || "";
        const i = opt?.dataset?.swatchImage || "";
        if (c) this.swatch.style.setProperty("--option-color", c);
        else this.swatch.style.removeProperty("--option-color");
        if (i) this.swatch.style.setProperty("--option-color-image", `url("${i}")`);
        else this.swatch.style.removeProperty("--option-color-image");
      } else {
        if (this.swatch.isConnected) this.swatch.remove();
      }
    }
    getLayer() {
      const existing = document.querySelector("[data-dropdown-select-layer='true']");
      if (existing && document.body.contains(existing)) return existing;
      const l = document.createElement("div");
      l.dataset.dropdownSelectLayer = "true";
      l.style.position = "fixed";
      l.style.inset = "0";
      l.style.pointerEvents = "none";
      l.style.zIndex = "1000";
      document.body.appendChild(l);
      return l;
    }
    schedulePositionMenu({ force = false } = {}) {
      if (!this.opened) return;
      if (!this.trigger || !this.menu) return;
      if (this.portal === "none") return;
      const scheduleRaf = () => {
        if (this.positionRaf) return;
        this.positionRaf = requestAnimationFrame(() => {
          this.positionRaf = 0;
          this.positionMenu();
        });
      };
      if (force) {
        scheduleRaf();
        return;
      }
      if (typeof requestIdleCallback === "function") {
        if (this.positionIdle && typeof cancelIdleCallback === "function") {
          cancelIdleCallback(this.positionIdle);
        }
        this.positionIdle = requestIdleCallback(
          () => {
            this.positionIdle = 0;
            scheduleRaf();
          },
          { timeout: 120 },
        );
        return;
      }
      scheduleRaf();
    }
    populateMenu() {
      if (!this.menu || !this.select) return;
      this.menu.innerHTML = "";
      const hasSwatchData = Array.from(this.select.options).some(
        (o) => !!(o?.dataset?.swatchColor || o?.dataset?.swatchImage),
      );
      const showSwatch = this.forceSwatch || hasSwatchData;

      Array.from(this.select.options).forEach((opt) => {
        const btn = document.createElement("button");
        btn.type = "button";
        this.addPartClass(btn, "option");
        btn.setAttribute("role", "option");
        btn.dataset.value = String(opt.value);
        btn.tabIndex = -1;
        btn.disabled = !!opt.disabled;
        if (opt.disabled) btn.setAttribute("aria-disabled", "true");

        if (showSwatch) {
          const sw = document.createElement("span");
          this.addPartClass(sw, "option-swatch");
          sw.setAttribute("aria-hidden", "true");
          const c = opt.dataset.swatchColor || "";
          const i = opt.dataset.swatchImage || "";
          if (c) sw.style.setProperty("--option-color", c);
          if (i) sw.style.setProperty("--option-color-image", `url("${i}")`);
          btn.appendChild(sw);
        }

        const label = document.createElement("span");
        this.addPartClass(label, "option-label");
        label.textContent = opt.textContent || "";
        btn.title = (opt.textContent || "").trim();
        btn.appendChild(label);

        btn.addEventListener("click", () => {
          if (btn.disabled) return;
          const next = String(opt.value);
          if (this.select.value !== next) {
            this.select.value = next;
            this.select.dispatchEvent(new Event("change", { bubbles: true }));
          }
          this.close({ focusTrigger: true });
        });

        this.menu.appendChild(btn);
      });
    }
    syncSelected() {
      if (!this.menu || !this.select) return;
      const current = String(this.select.value || "");
      const options = Array.from(this.menu.querySelectorAll("[role='option']"));
      options.forEach((b) => {
        const sel = b.dataset.value === current;
        b.classList.toggle("is-selected", sel);
        b.setAttribute("aria-selected", sel ? "true" : "false");
        if (sel) b.tabIndex = 0;
        else b.tabIndex = -1;
      });
    }
    open({ focusOption = false } = {}) {
      if (!this.trigger || !this.menu || !this.select) return;
      if (this.select.disabled) return;
      this.closeOthers();
      this.opened = true;
      this.menu.hidden = false;
      this.trigger.setAttribute("aria-expanded", "true");
      this.classList.add("is-open");
      if (this.openClassTargetSelector && this.openClassName) {
        this.closest(this.openClassTargetSelector)?.classList.add(this.openClassName);
      }
      this.origParent = this.menu.parentElement;
      this.origNext = this.menu.nextSibling;
      if (this.portal !== "none") {
        const layer = this.getLayer();
        if (!layer.contains(this.menu)) {
          this.menu.classList.add("is-fixed");
          this.menu.style.pointerEvents = "auto";
          layer.appendChild(this.menu);
        }
        this.schedulePositionMenu({ force: true });
      }
      this.syncSelected();
      if (focusOption) this.focusSelectedOption();
    }
    close({ focusTrigger = false } = {}) {
      if (!this.opened) return;
      this.opened = false;
      this.menu.hidden = true;
      this.trigger.setAttribute("aria-expanded", "false");
      this.classList.remove("is-open");
      if (this.openClassTargetSelector && this.openClassName) {
        this.closest(this.openClassTargetSelector)?.classList.remove(this.openClassName);
      }
      if (this.origParent && !this.origParent.contains(this.menu)) {
        if (this.origNext && this.origNext.parentNode === this.origParent) {
          this.origParent.insertBefore(this.menu, this.origNext);
        } else {
          this.origParent.appendChild(this.menu);
        }
      }
      this.menu.classList.remove("is-fixed");
      this.menu.style.pointerEvents = "";
      this.menu.style.position = "";
      this.menu.style.top = "";
      this.menu.style.left = "";
      this.menu.style.width = "";
      this.menu.style.maxHeight = "";
      this.menu.style.overflowY = "";
      if (this.positionRaf) {
        cancelAnimationFrame(this.positionRaf);
        this.positionRaf = 0;
      }
      if (this.positionIdle && typeof cancelIdleCallback === "function") {
        cancelIdleCallback(this.positionIdle);
        this.positionIdle = 0;
      }
      this.clearTypeahead();
      if (focusTrigger && this.trigger) this.trigger.focus();
    }
    closeOthers() {
      document
        .querySelectorAll("dropdown-select.is-open")
        .forEach((el) => el !== this && el.close());
    }
    focusSelectedOption() {
      if (!this.menu || !this.select) return;
      const current = String(this.select.value || "");
      const btn =
        Array.from(this.menu.querySelectorAll("[role='option']")).find(
          (b) => b.dataset.value === current,
        ) || this.menu.querySelector("[role='option']");
      if (btn && btn.focus) btn.focus();
    }
    teardownPositioning() {
      if (this.positionRaf) {
        cancelAnimationFrame(this.positionRaf);
        this.positionRaf = 0;
      }
      if (this.positionIdle && typeof cancelIdleCallback === "function") {
        cancelIdleCallback(this.positionIdle);
        this.positionIdle = 0;
      }
      if (this.refreshRaf) {
        cancelAnimationFrame(this.refreshRaf);
        this.refreshRaf = 0;
      }
      this.clearTypeahead();
    }
    teardownPortal() {
      const layer = document.querySelector("[data-dropdown-select-layer='true']");
      if (layer && layer.childElementCount === 0 && document.body.contains(layer)) layer.remove();
      if (
        this.menu &&
        this.origParent &&
        !this.origParent.contains(this.menu)
      ) {
        if (this.origNext && this.origNext.parentNode === this.origParent) {
          this.origParent.insertBefore(this.menu, this.origNext);
        } else {
          this.origParent.appendChild(this.menu);
        }
      }
    }
    positionMenu() {
      if (!this.trigger || !this.menu) return;
      if (this.portal === "none") return;
      const rect = this.trigger.getBoundingClientRect();
      const vw = window.innerWidth || document.documentElement.clientWidth;
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const gutter = 8;
      const w = Math.round(rect.width);
      let effectiveBottom = vh;
      if (this.avoidSelector) {
        const avoidEl = document.querySelector(this.avoidSelector);
        if (avoidEl) {
          const sr = avoidEl.getBoundingClientRect();
          if (sr.height > 0) effectiveBottom = Math.min(vh, sr.top);
        }
      }
      const below = effectiveBottom - rect.bottom - gutter;
      const above = rect.top - gutter;
      this.menu.style.maxHeight = "";
      this.menu.style.overflowY = "";
      this.menu.style.position = "fixed";
      this.menu.style.width = `${w}px`;
      const down = below >= 180 || below >= above;
      const viewportCap = Math.max(120, Math.floor(vh * 0.8));
      const availableH = Math.floor((down ? below : above) - gutter);
      const maxH = Math.min(viewportCap, Math.max(120, availableH));
      this.menu.style.maxHeight = `${maxH}px`;
      this.menu.style.overflowY = "auto";
      const left = Math.max(
        gutter,
        Math.min(Math.round(rect.left), vw - w - gutter),
      );
      this.menu.style.left = `${left}px`;
      const h = Math.min(this.menu.offsetHeight || 0, maxH);
      const top = down
        ? Math.round(rect.bottom + gutter)
        : Math.round(rect.top - gutter - h);
      this.menu.style.top = `${Math.max(gutter, top)}px`;
    }
    handleTriggerKeydown(e) {
      if (!this.trigger || !this.menu || !this.select) return;
      if (this.select.disabled) return;
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        if (this.menu.hidden) this.open({ focusOption: true });
        else this.close({ focusTrigger: true });
        return;
      }
      if (e.key === "ArrowDown" || e.key === "ArrowUp") {
        e.preventDefault();
        if (this.menu.hidden) this.open({ focusOption: false });
        const buttons = Array.from(this.menu.querySelectorAll("[role='option']"));
        if (!buttons.length) return;
        if (e.key === "ArrowUp") buttons[buttons.length - 1].focus();
        else this.focusSelectedOption();
        return;
      }
    }
    handleMenuKeydown(e) {
      if (!this.menu || this.menu.hidden) return;
      const buttons = Array.from(this.menu.querySelectorAll("[role='option']"));
      if (!buttons.length) return;
      const current = document.activeElement;
      const idx = buttons.indexOf(current);
      const currentIndex = idx >= 0 ? idx : 0;

      if (e.key === "Escape") {
        e.preventDefault();
        this.close({ focusTrigger: true });
        return;
      }
      if (e.key === "Tab") {
        this.close();
        return;
      }
      if (e.key === "ArrowDown" || e.key === "ArrowUp") {
        e.preventDefault();
        const delta = e.key === "ArrowDown" ? 1 : -1;
        const nextIndex = (currentIndex + delta + buttons.length) % buttons.length;
        buttons[nextIndex].focus();
        return;
      }
      if (e.key === "Home" || e.key === "End") {
        e.preventDefault();
        const next = e.key === "Home" ? buttons[0] : buttons[buttons.length - 1];
        next.focus();
        return;
      }
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        if (current && current.click) current.click();
        return;
      }
      if (e.key && e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {
        this.typeahead(e.key);
      }
    }
    typeahead(ch) {
      const now = Date.now();
      if (now - this.typeaheadTs > 650) this.typeaheadBuffer = "";
      this.typeaheadTs = now;
      this.typeaheadBuffer += ch.toLowerCase();
      if (this.typeaheadTimer) clearTimeout(this.typeaheadTimer);
      this.typeaheadTimer = setTimeout(() => this.clearTypeahead(), 700);

      const buttons = Array.from(this.menu.querySelectorAll("[role='option']"));
      if (!buttons.length) return;
      const start = Math.max(0, buttons.indexOf(document.activeElement));
      const all = buttons.slice(start + 1).concat(buttons.slice(0, start + 1));
      const hit = all.find((b) =>
        (b.textContent || "").trim().toLowerCase().startsWith(this.typeaheadBuffer),
      );
      if (hit) hit.focus();
    }
    clearTypeahead() {
      this.typeaheadBuffer = "";
      this.typeaheadTs = 0;
      if (this.typeaheadTimer) {
        clearTimeout(this.typeaheadTimer);
        this.typeaheadTimer = 0;
      }
    }
  }
  customElements.define("dropdown-select", DropdownSelect);
}
